import { render } from "./ReclamacaoTecnicaComercial.vue?vue&type=template&id=daee0230&scoped=true"
import script from "./ReclamacaoTecnicaComercial.vue?vue&type=script&lang=js"
export * from "./ReclamacaoTecnicaComercial.vue?vue&type=script&lang=js"

import "./ReclamacaoTecnicaComercial.vue?vue&type=style&index=0&id=daee0230&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daee0230"]])

export default __exports__